<template>
<div class="sideMenuWrapper" v-if="show">
  <nav class="navbar navbar-expand-lg">
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <SideMenuRoot :isDropDown="false" id="sideMenuRoot" :menuItems="menuItems"/>
    </div>
  </nav>
</div>
</template>

<script>
import SideMenuRoot from '@/components/Menus/SideMenuRoot.vue'

export default {
  name: 'SideMenu',
  components: {
    SideMenuRoot
  },
  data () {
    return {
      show: false,
      menuItems: [
        {
          label: 'Översikt',
          link: '/dashboard',
          icon: ['far', 'envelope']
        },
        {
          label: 'Ordrar',
          link: '',
          icon: ['fal', 'tasks'],
          menuItems: []
        },
        {
          label: 'Fakturor',
          link: '/invoicesList',
          icon: ['far', 'file-alt'],
          menuItems: [
            {
              label: 'Feralco',
              link: '/invoiceFeralcoList'
            },
            {
              label: 'Feralco Intern',
              link: '/invoiceFeralcoInternList'
            },
            {
              label: 'Standard',
              link: '/invoiceHydroList'
            },
            {
              label: 'Feralco Prislista',
              link: '/feralcoPricesListAdmin'
            }
          ]
        },
        {
          label: 'Planering',
          link: '/planning',
          icon: ['far', 'file-alt']
        },
        {
          label: 'Register',
          link: '',
          icon: ['far', 'file-alt'],
          menuItems: [
            {
              label: 'Kunder',
              link: '/customerList'
            },
            {
              label: 'Leveransställen',
              link: '/customerPlacesList'
            },
            {
              label: 'Användare',
              link: '/UserList'
            }
          ]
        },
        {
          label: 'Karta',
          link: '/mapview',
          icon: ['far', 'map']
        },
        {
          label: 'Statistik',
          link: '/dashboard',
          icon: ['far', 'chart-bar']
        }
      ]
    }
  },
  props: {
    isLoggedIn: Boolean
  },
  mounted () {
    this.show = this.$props.isLoggedIn
    this.$http.get('/api/orders/types')
      .then(response => {
        for (let menuItem of this.menuItems) {
          if (menuItem.label === 'Ordrar') {
            menuItem.menuItems = response.data.map((el) => ({
              label: el.name,
              link: '/OrderListByType/' + el.name
            }))
          }
        }
      })
      .catch(error => console.log(error))
    this.$http.get('/api/objectlabels')
      .then(response => {
        const mList = (arr) => (arr.map(descr => ({
          label: descr.name,
          link: '/objectDataList/' + descr.id
        })))
        const mGroup = (arr) => {
          return arr.map(el => {
            let menuItems = el.subgroup.length === 0 ? mList(el.descriptions) : mGroup(el.subgroup)
            return {
              label: el.group,
              link: '/objectDataList/' + el.id,
              ...(menuItems !== 'undefined' && { menuItems: menuItems })
            }
          })
        }
        for (let menuItem of this.menuItems) {
          if (menuItem.label === 'Register') {
            menuItem.menuItems = [...menuItem.menuItems, ...mGroup(response.data)]
          }
        }
      })
  },
  watch: {
    isLoggedIn: function (newVal) {
      this.show = newVal
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Menus/SideMenu.vue